module.exports = __webpack_public_path__ + "static/media/stekker.10d1576c.png";